import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import axios from "../../../../helpers/axios";
import {getSearchParam} from "../../components/getSearchParam";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import SearchForm from "../../components/searchForm";
import {Table} from "reactstrap";
import {Form, Tab, Tabs} from "react-bootstrap";
import _ from "lodash";
import numberFormat from "../../../../helpers/numberFormat";
import moment from "moment";
import {Helmet} from "react-helmet";
import sayError from "../../../../helpers/sayError";
import IssuedGroupedTable, {prepareGroupedTable} from "../../components/issuedGroupedTable";

const paymentSourceLabel = {
  "1C": "1С",
  "CASH": "Касса Google"
}

const IncomeReportPage = () => {
  const { search } = useLocation();
  const [issued, setIssued] = useState()
  const [payments, setPayments] = useState([])
  const [withNds, setWithNds] = useState(true)
  const [tabIndex, setTabIndex] = useState("summary")

  const applyResponse = (data, formData) => {
    setIssued(prepareGroupedTable(data.table))
    setPayments(Array.isArray(data.payments) ? data.payments : [])
    if (formData) {
      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname +
        `?start=${formData.start}&end=${formData.end}&id=${formData.counterparty}`;
      window.history.pushState({path: newurl}, '', newurl)
    }
  }

  useEffect(() => {
    if (search) {
      axios.post('/api/racoon/pdfParse/incomeReport/one', {
        ...getSearchParam(search),
        groupBySupplier: true
      }).then(({data}) => {
        applyResponse(data)
      }).catch(sayError)
    }
  }, []);

  const issuedTotals = {
    netto: _.sumBy(issued, 'netto') || 0,
    krs1C: _.sumBy(issued, 'krs1C') || 0,
    krsKayar1C: _.sumBy(issued, 'krsKayar1C') || 0,
    krsSite: _.sumBy(issued, 'krsSite') || 0,
    nds: _.sumBy(issued, 'nds') || 0,
  }
  issuedTotals.krsTotal = issuedTotals.krs1C + issuedTotals.krsKayar1C + issuedTotals.krsSite
  issuedTotals.total = issuedTotals.netto + issuedTotals.krsTotal +
    (withNds ? issuedTotals.nds : 0)

  const payments1C = _.sumBy(payments.filter(p => p.source === '1C'), 'total') || 0
  const paymentsCash = _.sumBy(payments.filter(p => p.source === 'CASH'), 'total') || 0
  const paymentsTotal = payments1C + paymentsCash

  const sortedPayments = _.sortBy(payments, p => moment(p.issueDate, ['DD.MM.YYYY', 'DD.MM.YY']).unix())

  return (
    <>
      <Helmet>
        <title>Отчет по доходу</title>
      </Helmet>
      <Portlet>
        <PortletHeader title={<div className={'d-flex gap-2 align-items-center'}>
          <h5>Отчет</h5>
          <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
            <input
              checked={withNds}
              onChange={() => setWithNds(!withNds)}
              type={"checkbox"}
            />{" "}
            НДС
          </Form.Label>
        </div>} toolbar={<PortletHeaderToolbar>
          <SearchForm one
                      grouped
                      cb={(data, formData) => applyResponse(data, formData)}
                      url={'/api/racoon/pdfParse/incomeReport/one'}/>
        </PortletHeaderToolbar>}/>
        {issued && <PortletBody className={'pt-2'}>
          <Tabs
            variant="underline"
            activeKey={tabIndex}
            onSelect={key => setTabIndex(key)}
          >
            <Tab eventKey="summary" title="Общее">
              <Table bordered className={'mt-3'} style={{maxWidth: 520}}>
                <tbody>
                <tr
                  style={{backgroundColor: "#d9ead3", cursor: "pointer"}}
                  onClick={() => setTabIndex("issued")}
                >
                  <th colSpan={2}>Выписано</th>
                </tr>
                <tr>
                  <td>Нетто</td>
                  <td className={'text-end'}>{numberFormat(issuedTotals.netto)}</td>
                </tr>
                <tr>
                  <td>Крс 1с</td>
                  <td className={'text-end'}>{numberFormat(issuedTotals.krs1C)}</td>
                </tr>
                {withNds && <tr>
                  <td>НДС</td>
                  <td className={'text-end'}>{numberFormat(issuedTotals.nds)}</td>
                </tr>}
                <tr>
                  <td>КрсКаяр 1с</td>
                  <td className={'text-end'}>{numberFormat(issuedTotals.krsKayar1C)}</td>
                </tr>
                <tr>
                  <td>Крс сайт</td>
                  <td className={'text-end'}>{numberFormat(issuedTotals.krsSite)}</td>
                </tr>
                <tr>
                  <th>Итого крс</th>
                  <th className={'text-end'}>{numberFormat(issuedTotals.krsTotal)}</th>
                </tr>
                <tr
                  style={{cursor: "pointer"}}
                  onClick={() => setTabIndex("issued")}
                >
                  <th>Итого выписано</th>
                  <th className={'text-end'}>{numberFormat(issuedTotals.total)}</th>
                </tr>
                <tr
                  style={{backgroundColor: "#cfe2f3", cursor: "pointer"}}
                  onClick={() => setTabIndex("payments")}
                >
                  <th colSpan={2}>Оплачено</th>
                </tr>
                <tr>
                  <td>Из 1С</td>
                  <td className={'text-end'}>{numberFormat(payments1C)}</td>
                </tr>
                <tr>
                  <td>Из кассы Google</td>
                  <td className={'text-end'}>{numberFormat(paymentsCash)}</td>
                </tr>
                <tr
                  style={{cursor: "pointer"}}
                  onClick={() => setTabIndex("payments")}
                >
                  <th>Итого оплачено</th>
                  <th className={'text-end'}>{numberFormat(paymentsTotal)}</th>
                </tr>
                <tr style={{backgroundColor: "#fff2cc"}}>
                  <th>Итого общее</th>
                  <th className={'text-end'}>{numberFormat(issuedTotals.total + paymentsTotal)}</th>
                </tr>
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="issued" title="Выписано">
              <div className={'mt-3'}>
                <IssuedGroupedTable data={issued} withNds={withNds}/>
              </div>
            </Tab>
            <Tab eventKey="payments" title={`Оплаты (${payments.length})`}>
              <div className={'tableFixOnlyHead mt-3'}>
                <Table bordered>
                  <thead>
                  <tr>
                    <th>Дата</th>
                    <th>Источник</th>
                    <th>Контрагент</th>
                    <th>Описание</th>
                    <th>Сумма</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style={{backgroundColor: "#d9ead3"}}>
                    <td colSpan={4}>Итого</td>
                    <td className={'text-end'}>{numberFormat(paymentsTotal)}</td>
                  </tr>
                  {sortedPayments.map((payment, index) => (
                    <tr key={index}>
                      <td>{payment.issueDate}</td>
                      <td>{paymentSourceLabel[payment.source] || payment.source || '—'}</td>
                      <td>{payment.counterparty}</td>
                      <td>{payment.description}</td>
                      <td className={'text-end'}>{numberFormat(payment.total)}</td>
                    </tr>
                  ))}
                  </tbody>
                </Table>
              </div>
            </Tab>
          </Tabs>
        </PortletBody>}
      </Portlet>
    </>
  );
};

export default IncomeReportPage;
